import React, { useEffect, useState } from 'react'
import { StyledHeader } from './styled'
import Session from 'javascripts/layouts/v2/Session'

interface HeaderProps {
  session: Session;
}

const Index: React.FC<HeaderProps> = (props: HeaderProps) => {
  return (
    <StyledHeader session={props.session} />
  )
}

export default Index
